import React from 'react';

import { Container } from './styles';

const DefaultColumnBody = ({ children, ...rest }) => {
  return <Container {...rest}>{children}</Container>;
};

export default DefaultColumnBody;
